module.exports = __webpack_public_path__ + "img/autito.fde37e04.webp";